import { transition } from "@codesandbox/states";
import type { ApiEvent } from "environment-interface/api";

export type State =
  | { state: "READY" }
  | {
      state: "CREATING_BRANCH";
      sourceBranchName?: string;
      newBranchName: string;
      workspaceId: string | null;
    }
  | {
      state: "BRANCH_CREATE_ERROR";
      message: string;
      workspaceId: string | null;
    } // Special error for branch creation error
  | {
      state: "FORKING_BRANCH";
      workspaceId: string | null;
    }
  | { state: "CREATING_DRAFT_BRANCH"; sourceBranchName?: string };

export type PublicAction =
  | {
      type: "CREATE_BRANCH";
      sourceBranchName?: string;
      branchName: string;
      workspaceId: string | null;
    }
  | { type: "CREATE_DRAFT_BRANCH"; sourceBranchName?: string }
  | { type: "CREATE_FORK"; workspaceId: string }
  | { type: "CREATE_CONTRIBUTION_BRANCH" }
  | { type: "DISMISS_ERROR" };

export type PrivateAction = ApiEvent;

export type Action = PublicAction | PrivateAction;

export const reducer = (prevState: State, action: Action) =>
  transition(prevState, action, {
    READY: {
      CREATE_BRANCH: (_, { branchName, sourceBranchName, workspaceId }) => ({
        state: "CREATING_BRANCH",
        sourceBranchName,
        newBranchName: branchName,
        workspaceId,
      }),
      CREATE_CONTRIBUTION_BRANCH: () => ({
        state: "CREATING_DRAFT_BRANCH",
      }),
      CREATE_FORK: (_, { workspaceId }) => ({
        state: "FORKING_BRANCH",
        workspaceId,
      }),
      CREATE_DRAFT_BRANCH: (_, { sourceBranchName }) => ({
        state: "CREATING_DRAFT_BRANCH",
        sourceBranchName,
      }),
    },
    CREATING_BRANCH: {
      "API:CREATE_BRANCH_ERROR": (_, { error, workspaceId }) => ({
        state: "BRANCH_CREATE_ERROR",
        message: error,
        workspaceId,
      }),
      "API:CREATE_BRANCH_SUCCESS": () => ({
        state: "READY",
      }),
      // Due to permissions this can cause a fork, will be moved
      // to own hook later
      "API:FORK_BRANCH_SUCCESS": () => ({
        state: "READY",
      }),
      "API:FORK_BRANCH_ERROR": (_, { message, workspaceId }) => ({
        state: "BRANCH_CREATE_ERROR",
        message,
        workspaceId,
      }),
    },
    FORKING_BRANCH: {
      "API:FORK_BRANCH_SUCCESS": () => ({
        state: "READY",
      }),
      "API:FORK_BRANCH_ERROR": (_, { message, workspaceId }) => ({
        state: "BRANCH_CREATE_ERROR",
        message,
        workspaceId,
      }),
    },
    CREATING_DRAFT_BRANCH: {
      "API:CREATE_BRANCH_SUCCESS": () => ({
        state: "READY",
      }),
      "API:CREATE_BRANCH_ERROR": (_, { error, workspaceId }) => ({
        state: "BRANCH_CREATE_ERROR",
        message: error,
        workspaceId,
      }),
    },
    BRANCH_CREATE_ERROR: {
      DISMISS_ERROR: () => ({
        state: "READY",
      }),
    },
  });
